
/**
 * 邮箱
 * @param {*} s
 */
export function isEmail (s) {
  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile (s) {
  return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone (s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}

export function timeFormat (timeStamp, type) {
  let year = new Date(timeStamp).getFullYear()
  let month = new Date(timeStamp).getMonth() + 1 < 10 ? '0' + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1
  let date = new Date(timeStamp).getDate() < 10 ? '0' + new Date(timeStamp).getDate() : new Date(timeStamp).getDate()
  let hh = new Date(timeStamp).getHours() < 10 ? '0' + new Date(timeStamp).getHours() : new Date(timeStamp).getHours()
  let mm = new Date(timeStamp).getMinutes() < 10 ? '0' + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes()
  let ss = new Date(timeStamp).getSeconds() < 10 ? '0' + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds()
  if (type === 'yymmdd') {
    return year + '-' + month + '-' + date
  } else if (type === 'yymmddhhmm') {
    return year + '-' + month + '-' + date + ' ' + hh + ':' + mm
  } else {
    return year + '-' + month + '-' + date + ' ' + hh + ':' + mm + ':' + ss
  }
}

export function funDate (date) {
  let date1 = new Date() // time1表示当前时间
  let date2 = new Date(date1)
  date2.setDate(date1.getDate() + date)
  let time2 = date2.getFullYear() + '-' + (date2.getMonth() + 1) + '-' + date2.getDate()
  return time2
}
/* 获取地址栏参数 */
export function getQueryStringRegExp (name) {
  let reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i')
  if (reg.test(location.href)) {
    return unescape(RegExp.$2.replace(/\+/g, ' '))
  } else {
    return ''
  }
}

// 获取现在的时间 2020-4-20的样式
export function getTime () {
  var date = ''
  var def = new Date()
  if (date === '') {
    date = def.getFullYear() + '-' + (def.getMonth() + 1) + '-' + def.getDate()
  }
  return date
}



// WEBPACK FOOTER //
// ./src/utils/validate.js